import { Box } from "@mui/material";
import { FormEventHandler, ReactNode } from "react";
import FormTitle from "src/components/Displays/FormTitle";
import ContentCard from "src/components/Shared/ContentCard";
import FormSubTitle from "src/components/Displays/FormSubTitle";

interface FormContainerProps {
  title?: string;
  subTitle?: string;
  children: ReactNode;
  onSubmit: FormEventHandler<HTMLFormElement> | undefined;
}

const FormContainer = ({
  title,
  onSubmit,
  subTitle,
  children,
}: FormContainerProps) => {
  return (
    <ContentCard>
      {title && <FormTitle text={title} />}
      {subTitle && <FormSubTitle text={subTitle} />}
      <Box component={"form"} autoComplete="off" onSubmit={onSubmit}>
        {children}
      </Box>
    </ContentCard>
  );
};

export default FormContainer;
